import {
    SvgGraphics,
} from '@tencent/alloy-renderer';
import { IFrame } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-graphic/graphic-component.interface';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { setElementStyle } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/utils/style-render';
import { getOriginStyle } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/utils/style';

export interface ChartBackgroundProps {
    frame: IFrame;
    style: any;
    factoryOptions: InterfaceFactoryOptions<IChartModel>;
}

export class ChartBackgroundComponent extends SvgGraphics {
    props: ChartBackgroundProps;

    public constructor(props: ChartBackgroundProps) {
        super();
        this.props = props;
        this.updateStyles();
    }

    public updateProps(props: ChartBackgroundProps) {
        this.props = props;
        this.updateStyles();
    }

    private updateStyles(): void {
        const { frame, factoryOptions } = this.props;
        const { width, height, left = 0, top = 0 } = frame;
        this.path = rectToPath(width, height);
        this.x = left;
        this.y = top;

        setElementStyle(this, getOriginStyle(this.props), factoryOptions);
    }
}

function rectToPath(width: number, height: number) {
    return `M 0 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`;
}
